import { parseISO, isSameDay, isBefore } from 'date-fns';

export const dateFilterParams = {
  comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
    const dateAsString = cellValue;

    if (!dateAsString) {
      return -1;
    }

    const cellDate = parseISO(dateAsString);
    if (isSameDay(filterLocalDateAtMidnight, cellDate)) {
      return 0;
    }

    if (isBefore(cellDate, filterLocalDateAtMidnight)) {
      return -1;
    } else {
      return 1;
    }
  },
  browserDatePicker: true,
  minValidYear: 1950,
  maxValidYear: 2050,
  buttons: ['reset'],
};
